export default __webpack_public_path__ + "static/media/no-access.37e71971.png";